import {errorResponseSchema} from '../common/ErrorResponseSchema';

// pick: errorResponseSchema.cause (z.unknown) breaks Hono's typed context.json
export const AutoplacPlFeedErrorResponseSchema = errorResponseSchema
  .pick({
    code: true,
    message: true,
  })
  .openapi('AutoplacPlFeedErrorResponse');
